<div class="card-reprovacao" *ngIf="mensagem">
    <div class="py-2">
        <span class="ms-2 fw-bold color-cinza-da-noite" *ngIf="titulo">{{titulo}}</span>
        <p class="mb-0 ms-2 color-cinza-da-noite">
            {{mensagem}}
        </p>
    </div>
</div>
